import { useCallback, useEffect, useState } from "react";

/**
 * Instagram-style sidebar expansion: hover is temporary.
 * Visual expansion = hover-expanded. Hover is a no-op when disabled (mobile).
 */
export const useSidebarExpansion = ({ hoverEnabled = true } = {}) => {
  const [isHoverExpanded, setIsHoverExpanded] = useState(false);

  useEffect(() => {
    if (!hoverEnabled) setIsHoverExpanded(false);
  }, [hoverEnabled]);

  const handleMouseEnter = useCallback(() => {
    if (!hoverEnabled) return;
    setIsHoverExpanded(true);
  }, [hoverEnabled]);

  const handleMouseLeave = useCallback(() => {
    if (!hoverEnabled) return;
    setIsHoverExpanded(false);
  }, [hoverEnabled]);

  return {
    isHoverExpanded,
    isExpanded: isHoverExpanded,
    handleMouseEnter,
    handleMouseLeave,
  };
};
